import { CLEAR_ALL, LOGOUT } from '../../../../store/Types';

export const ALL_ENTHOR_BLOQUES = 'ALL_ENTHOR_BLOQUES';
export const LOADING_ALL_ENTHOR_BLOQUES = 'LOADING_ALL_ENTHOR_BLOQUES';
export const ACTIVO_ENTHOR_BLOQUES = 'ACTIVO_ENTHOR_BLOQUES';
export const PARAMS_ENTHOR_BLOQUES = 'PARAMS_ENTHOR_BLOQUES';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const entHorBloquesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_ENTHOR_BLOQUES:
      return {
        ...state,
        all: action.payload.data,
        pagination: action.payload.meta,
      };
    case LOADING_ALL_ENTHOR_BLOQUES:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_ENTHOR_BLOQUES:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_ENTHOR_BLOQUES:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
